import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BronchitisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Bronchitis</h1>
        <section className="mb-8">
          <p>Bronchitis is an inflammation of the bronchial tubes, which carry air to and from your lungs. It often causes coughing, mucus production, and chest discomfort. While acute bronchitis is usually short-lived, chronic bronchitis can persist and impact daily life. Natural remedies can help soothe symptoms and support lung health.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Viral or bacterial infections</li>
            <li>Exposure to smoke or pollutants</li>
            <li>Allergies</li>
            <li>Weakened immune system</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Persistent cough</li>
            <li>Production of mucus (clear, white, yellow, or green)</li>
            <li>Chest discomfort</li>
            <li>Shortness of breath</li>
            <li>Fatigue</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use soothing herbs and natural therapies to reduce inflammation, clear mucus, and strengthen the respiratory system. Our treatments are gentle, safe, and designed to promote faster recovery and long-term lung health.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eases coughing and congestion</li>
            <li>Supports immune function</li>
            <li>No harsh side effects</li>
            <li>Promotes natural healing</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Stay hydrated</li>
            <li>Avoid smoke and irritants</li>
            <li>Practice deep breathing exercises</li>
            <li>Rest and allow your body to heal</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal remedies cure bronchitis?</strong>
            <p>A: They can help manage symptoms and speed recovery, especially when combined with healthy habits.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for children and elderly?</strong>
            <p>A: Yes, our treatments are gentle and can be customized for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I feel better?</strong>
            <p>A: Most patients notice improvement within a week.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from bronchitis—book your herbal consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default BronchitisPage; 